import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useMemo } from 'react';
import { describe } from 'react-desc';
import { aggregatedClasses, convertPropToCssClassName } from '@elliemae/ds-classnames';
import { props } from './props.js';
import { defaultProps } from './defaultProps.js';

var CounterArea = aggregatedClasses('div')('counter', 'textarea', function (_ref) {
  var limitError = _ref.limitError;
  return {
    'limit-error': limitError
  };
});

var DSLargeInputText = function DSLargeInputText(_ref2) {
  var containerProps = _ref2.containerProps,
      autoFocus = _ref2.autoFocus,
      className = _ref2.className,
      disabled = _ref2.disabled,
      name = _ref2.name,
      id = _ref2.id,
      maxLength = _ref2.maxLength,
      minLength = _ref2.minLength,
      placeholder = _ref2.placeholder,
      onClick = _ref2.onClick,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onKeyUp = _ref2.onKeyUp,
      onKeyDown = _ref2.onKeyDown,
      onPaste = _ref2.onPaste,
      value = _ref2.value,
      hasError = _ref2.hasError,
      required = _ref2.required,
      readOnly = _ref2.readOnly,
      resize = _ref2.resize,
      innerRef = _ref2.innerRef,
      ariaLabel = _ref2.ariaLabel,
      ariaAutocomplete = _ref2.ariaAutocomplete,
      role = _ref2.role,
      characterLimitCounter = _ref2.characterLimitCounter,
      rows = _ref2.rows,
      errorLimit = _ref2.errorLimit,
      tabIndex = _ref2.tabIndex;
  var limitError = useMemo(function () {
    return characterLimitCounter < String(value).length && characterLimitCounter > 0;
  }, [characterLimitCounter, value]);

  var _convertPropToCssClas = convertPropToCssClassName('form-element-textarea', 'text', {
    hasError: limitError || hasError,
    readOnly: readOnly,
    disabled: disabled
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameElement = _convertPropToCssClas.classNameElement,
      classNameBlock = _convertPropToCssClas.classNameBlock; // auto size when user types


  var handleKeyUp = function handleKeyUp(e) {
    // const { target } = e
    onKeyUp(e); // if (e.key !== 'Enter') return
    // target.style.cssText = 'height:auto; padding:0'
    // target.style.cssText = `height: ${target.scrollHeight}px`
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, containerProps, {
    className: "".concat(cssClassName, " ").concat(className)
  }), /*#__PURE__*/React.createElement("div", {
    className: classNameBlock('wrapper')
  }, /*#__PURE__*/React.createElement("textarea", {
    ref: innerRef,
    "aria-autocomplete": ariaAutocomplete,
    "aria-label": ariaLabel,
    "aria-multiline": true,
    "aria-placeholder": placeholder,
    "aria-required": required,
    autoFocus: autoFocus,
    className: classNameElement('textarea'),
    "data-testid": "ds-large-input_main-component",
    disabled: disabled,
    id: id,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: handleKeyUp,
    onPaste: onPaste,
    placeholder: placeholder,
    role: role,
    rows: String(rows),
    style: {
      resize: resize
    },
    value: value,
    tabIndex: tabIndex
  }))), characterLimitCounter > 0 && /*#__PURE__*/React.createElement(CounterArea, {
    classProps: {
      limitError: limitError
    },
    "data-testid": "counter-area"
  }, "".concat(limitError ? "".concat(errorLimit, " ").concat(characterLimitCounter, " characters.   ") : '').concat(String(value).length, " / ").concat(characterLimitCounter)));
};

DSLargeInputText.propTypes = props;
DSLargeInputText.defaultProps = defaultProps;
var DSLargeInputTextWithSchema = describe(DSLargeInputText).description('A large input');
DSLargeInputTextWithSchema.propTypes = props;

export default DSLargeInputText;
export { DSLargeInputTextWithSchema };
//# sourceMappingURL=DSLargeInputText.js.map
